<template>
  <DefaultField :field="field" :errors="errors" full-width-content :show-help-text="showHelpText">
    <template #label>
      <div></div>  
    </template>
    <template #field>
        <div class="w-full flex flex-wrap items-center gap-2" >
            <Link v-for="button in currentField.buttons" :key="button.name" :href="button.url" class="panel-primary-btn w-64">
                {{ button.name }}
            </Link>
        </div>
    </template>
  </DefaultField>
</template>

<script>
import { DependentFormField, HandlesValidationErrors } from '@/mixins'

export default {
    mixins: [DependentFormField, HandlesValidationErrors],

    props: ['resourceName', 'resourceId', 'field'],


    computed: {
        buttons() {
            return this.currentField.buttons;
        },
    },
}
</script>